export var provider = 'adyen';
export var configuration = {
    locale: 'en-US',
    analytics: {
        enabled: true,
    },
    showPayButton: true,
    paymentMethodsConfiguration: {
        ideal: {
            showImage: true,
        },
        card: {
            hasHolderName: true,
            holderNameRequired: true,
            name: 'Credit or debit card',
        },
    },
};
export var getCustomPayButton = function () { return document.querySelector('#adyen-pay-button'); };
export var initCustomPayButton = function (submitHandler) {
    var adyenPayButton = getCustomPayButton();
    if (adyenPayButton) {
        adyenPayButton.disabled = false;
        adyenPayButton.addEventListener('click', submitHandler);
    }
};
export var getLocale = function () { return window.backEndVars.locale; };
